import React from 'react';

const partners = [
    { name: 'Nike', src: '/logos/partners/nike.svg', height: 'h-8 md:h-10' },
    { name: 'Harvard Athletics', src: '/logos/partners/harvard.svg', height: 'h-10 md:h-14' },
    { name: 'UCLA', src: '/logos/partners/ucla.svg', height: 'h-8 md:h-10' },
    { name: 'Stanford', src: '/logos/partners/stanford.svg', height: 'h-10 md:h-14' },
    { name: 'WHOOP', src: '/logos/whoop/Logo/Wordmark/WHOOP Logo White.svg', height: 'h-8 md:h-10' },
];

const LogoStrip: React.FC<{ index: number }> = ({ index }) => (
    <div
        className="partners-strip flex items-center shrink-0"
        aria-hidden={index > 0}
    >
        {partners.map((partner) => (
            <div
                key={partner.name}
                className="shrink-0 px-16 md:px-24 flex items-center justify-center"
                style={{ transform: 'translateZ(0)' }}
            >
                <img
                    src={partner.src}
                    alt={partner.name}
                    className={`${partner.height} w-auto object-contain hover:scale-110 transition-transform duration-300`}
                />
            </div>
        ))}
    </div>
);

const PartnersCarousel: React.FC = () => {
    return (
        <section className="border-y border-white/10 py-12 md:py-16 overflow-hidden observe-fade opacity-0 bg-black notebook-grid">
            <div className="partners-track flex w-max">
                <LogoStrip index={0} />
                <LogoStrip index={1} />
            </div>
            <style>{`
                .partners-track {
                    animation: partners-scroll 30s linear infinite;
                }
                .partners-track:hover {
                    animation-play-state: paused;
                }
                @keyframes partners-scroll {
                    0% { transform: translate3d(0, 0, 0); }
                    100% { transform: translate3d(-50%, 0, 0); }
                }
            `}</style>
        </section>
    );
};

export default PartnersCarousel;
